import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})
export class OrderService extends ApiService {
    public getOrders(data: any) {
        return this.getOrderQueryParams(CONSTANTS.API.ORDER.GET_ORDERS, data);
    }
    public cancelOrder(params: any, data: any) {
        return this.deleteOrderQueryParams(CONSTANTS.API.ORDER.CANCEL_ORDER, params, data);
    }
}
